<div class="d-flex align-items-center d-block h-100" [style]="customStyle">
    <span class="text-wrapper" #textInformation [matTooltip]="isTextHasEllipsis(textInformation) ? text : undefined" matTooltipClass="custom-tooltip-text" matTooltipPosition="after">
        {{text}}
    </span>
</div>
    